import { render } from "./CmsOrders.vue?vue&type=template&id=279e2e07&scoped=true"
import script from "./CmsOrders.vue?vue&type=script&lang=js"
export * from "./CmsOrders.vue?vue&type=script&lang=js"

import "./CmsOrders.vue?vue&type=style&index=0&id=279e2e07&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279e2e07"]])

export default __exports__